import {onDomReady} from "./observer.js";

class Chat {
    constructor() {
        this.options = {
            chatSelect: '[data-chat-select]',
            chatSelectAll: '[data-chat-selectall]',
            chatSelectCancel: '[data-chat-select-cancel]',
            chatContacts: '[data-chat-contacts]',
            chatTextInput: '[data-chat-text-input]',
            chatStory: '[data-chat-story]',
            chatStoryOpener: '[data-chat-story-opener]',
            chatStoryCloser: '[data-chat-story-closer]',
            // chatComposerAddon: '[data-chat-composer-addon]',
            // chatComposerAddonCloser: '[data-chat-composer-addon-closer]',
            chatComposerAddonSmilesOpener: '[data-chat-composer-addon-smiles-opener]',
            chatComposerAddonAttachOpener: '[data-chat-composer-addon-attach-opener]',
            chatComposerAddonAttach: '[data-chat-composer-addon-attach]',
            chatComposerSmilesAttach: '[data-chat-composer-addon-smiles]',
            chatContactsOpenedClass: '_select',
            chatStoryOpenedClass: '_active',
            chatComposerAddonOpenedClass: '_opened',
        };

        this.elements = {
            chatSelectElement: document.querySelector(this.options.chatSelect),
            chatSelectAllElement: document.querySelector(this.options.chatSelectAll),
            chatSelectCancelElement: document.querySelector(this.options.chatSelectCancel),
            chatContactsElement: document.querySelector(this.options.chatContacts),
            chatTextInputElement: document.querySelector(this.options.chatTextInput),
            chatStoryElement: document.querySelector(this.options.chatStory),
            chatStoryOpenerElement: document.querySelector(this.options.chatStoryOpener),
            chatStoryCloserElement: document.querySelector(this.options.chatStoryCloser),
            // chatComposerAddonElement: document.querySelector(this.options.chatComposerAddon),
            // chatComposerAddonCloserElement: document.querySelector(this.options.chatComposerAddonCloser),
            chatComposerAddonSmilesOpenerElement: document.querySelector(this.options.chatComposerAddonSmilesOpener),
            chatComposerAddonAttachOpenerElement: document.querySelector(this.options.chatComposerAddonAttachOpener),
            chatComposerAddonAttachElement: document.querySelector(this.options.chatComposerAddonAttach),
            chatComposerAddonSmilesElement: document.querySelector(this.options.chatComposerSmilesAttach),
        };

        this.init();
    }

    init() {

        if (this.elements.chatComposerAddonAttachElement &&
            this.elements.chatComposerAddonAttachOpenerElement) {
            const chatComposerAttachVar = this.elements.chatComposerAddonAttachElement;
            const chatComposerAddonAttachOpenerVar = this.elements.chatComposerAddonAttachOpenerElement;
            const chatComposerAddonSmilesVar = this.elements.chatComposerAddonSmilesElement;

            chatComposerAddonAttachOpenerVar.addEventListener('click', () => {
                if (!chatComposerAttachVar.classList.contains(this.options.chatComposerAddonOpenedClass)) {
                    if (chatComposerAddonSmilesVar) {
                        if (chatComposerAddonSmilesVar.classList.contains(this.options.chatComposerAddonOpenedClass)) {
                            chatComposerAddonSmilesVar.classList.remove(this.options.chatComposerAddonOpenedClass);
                        }
                    }
                    chatComposerAttachVar.classList.add(this.options.chatComposerAddonOpenedClass);
                }
                else
                    chatComposerAttachVar.classList.remove(this.options.chatComposerAddonOpenedClass);
            });
        }


        if (this.elements.chatComposerAddonSmilesElement &&
            this.elements.chatComposerAddonSmilesOpenerElement) {
            const chatComposerSmilesVar = this.elements.chatComposerAddonSmilesElement;
            const chatComposerAddonSmilesOpenerVar = this.elements.chatComposerAddonSmilesOpenerElement;
            const chatComposerAddonAttachVar = this.elements.chatComposerAddonAttachElement;

            chatComposerAddonSmilesOpenerVar.addEventListener('click', () => {
                if (!chatComposerSmilesVar.classList.contains(this.options.chatComposerAddonOpenedClass)) {
                    if (chatComposerAddonAttachVar) {
                        if (chatComposerAddonAttachVar.classList.contains(this.options.chatComposerAddonOpenedClass)) {
                            chatComposerAddonAttachVar.classList.remove(this.options.chatComposerAddonOpenedClass);
                        }
                    }
                    chatComposerSmilesVar.classList.add(this.options.chatComposerAddonOpenedClass);
                }
                else
                    chatComposerSmilesVar.classList.remove(this.options.chatComposerAddonOpenedClass);
            });
        }

        /*
        if (this.elements.chatComposerAddonElement &&
            this.elements.chatComposerAddonCloserElement) {
            const chatComposerAddonVar = this.elements.chatStoryElement;
            const chatComposerAddonCloserVar = this.elements.chatStoryOpenerElement;
            const chatStoryCloserVar = this.elements.chatStoryCloserElement;
            const chatContactsVar = this.elements.chatContactsElement;
            chatStoryOpenerVar.addEventListener('click', () => {
                if (!chatContactsVar.classList.contains(this.options.chatContactsOpenedClass)) {
                    chatStoryVar.classList.add(this.options.chatStoryOpenedClass);
                }
            });
            chatStoryCloserVar.addEventListener('click', () => {
                chatStoryVar.classList.remove(this.options.chatStoryOpenedClass);
            });
        }
         */

        if (this.elements.chatStoryElement &&
            this.elements.chatStoryOpenerElement &&
            this.elements.chatStoryCloserElement &&
            this.elements.chatContactsElement) {
            const chatStoryVar = this.elements.chatStoryElement;
            const chatStoryOpenerVar = this.elements.chatStoryOpenerElement;
            const chatStoryCloserVar = this.elements.chatStoryCloserElement;
            const chatContactsVar = this.elements.chatContactsElement;
            chatStoryOpenerVar.addEventListener('click', () => {
                if (!chatContactsVar.classList.contains(this.options.chatContactsOpenedClass)) {
                    chatStoryVar.classList.add(this.options.chatStoryOpenedClass);
                }
            });
            chatStoryCloserVar.addEventListener('click', () => {
                chatStoryVar.classList.remove(this.options.chatStoryOpenedClass);
            });
        }

        // activate contacts selection mode
        if (this.elements.chatSelectElement &&
            this.elements.chatContactsElement &&
            this.elements.chatSelectCancelElement) {
            const chatSelectVar = this.elements.chatSelectElement;
            const chatContactsVar = this.elements.chatContactsElement;
            const chatSelectCancelVar = this.elements.chatSelectCancelElement;
            chatSelectVar.addEventListener('click', () => {
                chatContactsVar.classList.add(this.options.chatContactsOpenedClass);
            });
            chatSelectCancelVar.addEventListener('click', () => {
                chatContactsVar.classList.remove(this.options.chatContactsOpenedClass);
            });

            // todo: make class vars for search-classes
            const chatContactsItemsVar = chatContactsVar.querySelectorAll('.chat__contacts-item');
            chatContactsItemsVar.forEach(element => {
                element.addEventListener('click', function() {
                    if (chatContactsVar.classList.contains('_select')) {
                        const checkbox = element.querySelector('input[type="checkbox"]');
                        if (checkbox) {
                            checkbox.checked = !checkbox.checked;
                        }
                    }
                });
            });
        }

        // select all contacts for action
        if (this.elements.chatSelectAllElement) {
            const chatSelectAllVar = this.elements.chatSelectAllElement;
            chatSelectAllVar.addEventListener('click', () => {
                const checkboxes = document.querySelectorAll('.chat__contacts .chat__contacts-item input[type="checkbox"]');
                const allChecked = Array.from(checkboxes).every(checkbox => checkbox.checked);
                checkboxes.forEach(checkbox => {
                    checkbox.checked = !allChecked;
                });
            });
        }


        // chat input field size
        if (this.elements.chatTextInputElement) {
            const chatTextInputVar = this.elements.chatTextInputElement;
            chatTextInputVar.addEventListener('input', function () {
                this.style.height = 'auto'; // Reset height to recalculate
                if (this.scrollHeight < 200) {
                    this.style.height = this.scrollHeight + 'px'; // Set new height based on content
                    this.style.overflowY = 'hidden';
                } else {
                    this.style.height = '200px';
                    this.style.overflowY = 'auto';
                }
            });
        }
    }
}

onDomReady(() => {
    const header = new Chat();
}, false);